/* eslint-disable object-property-newline */
export type SlotDef =
  | { kind: 'group_winner'; group: string }
  | { kind: 'group_runner_up'; group: string }
  | { kind: 'best_3rd'; groups: string[] }
  | { kind: 'match_winner'; matchId: number }
  | { kind: 'match_runner_up'; matchId: number };

export interface KnockoutMatchDef {
  id: number;
  date: string;
  venue: string;
  home: SlotDef;
  away: SlotDef;
}

export interface KnockoutRound {
  name: string;
  matches: KnockoutMatchDef[];
}

export const KNOCKOUT_ROUNDS: KnockoutRound[] = [
  {
    name: 'Round of 32',
    matches: [
      {
        id: 73, date: 'Sun 28 Jun', venue: 'Los Angeles',
        home: { kind: 'group_runner_up', group: 'Group A' },
        away: { kind: 'group_runner_up', group: 'Group B' },
      },
      {
        id: 74, date: 'Mon 29 Jun', venue: 'Boston',
        home: { kind: 'group_winner', group: 'Group E' },
        away: { kind: 'best_3rd', groups: ['A', 'B', 'C', 'D', 'F'] },
      },
      {
        id: 76, date: 'Mon 29 Jun', venue: 'Houston',
        home: { kind: 'group_winner', group: 'Group C' },
        away: { kind: 'group_runner_up', group: 'Group F' },
      },
      {
        id: 75, date: 'Mon 29 Jun', venue: 'Monterrey',
        home: { kind: 'group_winner', group: 'Group F' },
        away: { kind: 'group_runner_up', group: 'Group C' },
      },
      {
        id: 77, date: 'Tue 30 Jun', venue: 'New York/NJ',
        home: { kind: 'group_winner', group: 'Group I' },
        away: { kind: 'best_3rd', groups: ['C', 'D', 'F', 'G', 'H'] },
      },
      {
        id: 78, date: 'Tue 30 Jun', venue: 'Dallas',
        home: { kind: 'group_runner_up', group: 'Group E' },
        away: { kind: 'group_runner_up', group: 'Group I' },
      },
      {
        id: 79, date: 'Wed 1 Jul', venue: 'Mexico City',
        home: { kind: 'group_winner', group: 'Group A' },
        away: { kind: 'best_3rd', groups: ['C', 'E', 'F', 'H', 'I'] },
      },
      {
        id: 80, date: 'Wed 1 Jul', venue: 'Atlanta',
        home: { kind: 'group_winner', group: 'Group L' },
        away: { kind: 'best_3rd', groups: ['E', 'H', 'I', 'J', 'K'] },
      },
      {
        id: 81, date: 'Wed 1 Jul', venue: 'San Francisco',
        home: { kind: 'group_winner', group: 'Group D' },
        away: { kind: 'best_3rd', groups: ['B', 'E', 'F', 'I', 'J'] },
      },
      {
        id: 82, date: 'Wed 1 Jul', venue: 'Seattle',
        home: { kind: 'group_winner', group: 'Group G' },
        away: { kind: 'best_3rd', groups: ['A', 'E', 'H', 'I', 'J'] },
      },
      {
        id: 83, date: 'Thu 2 Jul', venue: 'Toronto',
        home: { kind: 'group_runner_up', group: 'Group K' },
        away: { kind: 'group_runner_up', group: 'Group L' },
      },
      {
        id: 84, date: 'Thu 2 Jul', venue: 'Los Angeles',
        home: { kind: 'group_winner', group: 'Group H' },
        away: { kind: 'group_runner_up', group: 'Group J' },
      },
      {
        id: 85, date: 'Thu 2 Jul', venue: 'Vancouver',
        home: { kind: 'group_winner', group: 'Group B' },
        away: { kind: 'best_3rd', groups: ['E', 'F', 'G', 'I', 'J'] },
      },
      {
        id: 86, date: 'Fri 3 Jul', venue: 'Miami',
        home: { kind: 'group_winner', group: 'Group J' },
        away: { kind: 'group_runner_up', group: 'Group H' },
      },
      {
        id: 87, date: 'Fri 3 Jul', venue: 'Kansas City',
        home: { kind: 'group_winner', group: 'Group K' },
        away: { kind: 'best_3rd', groups: ['D', 'E', 'I', 'J', 'L'] },
      },
      {
        id: 88, date: 'Fri 3 Jul', venue: 'Dallas',
        home: { kind: 'group_runner_up', group: 'Group D' },
        away: { kind: 'group_runner_up', group: 'Group G' },
      }
    ],
  },
  {
    name: 'Round of 16',
    matches: [
      {
        id: 89, date: 'Sat 4 Jul', venue: 'Philadelphia',
        home: { kind: 'match_winner', matchId: 74 },
        away: { kind: 'match_winner', matchId: 77 },
      },
      {
        id: 90, date: 'Sat 4 Jul', venue: 'Houston',
        home: { kind: 'match_winner', matchId: 73 },
        away: { kind: 'match_winner', matchId: 75 },
      },
      {
        id: 91, date: 'Sun 5 Jul', venue: 'New York/NJ',
        home: { kind: 'match_winner', matchId: 76 },
        away: { kind: 'match_winner', matchId: 78 },
      },
      {
        id: 92, date: 'Sun 5 Jul', venue: 'Mexico City',
        home: { kind: 'match_winner', matchId: 79 },
        away: { kind: 'match_winner', matchId: 80 },
      },
      {
        id: 93, date: 'Mon 6 Jul', venue: 'Dallas',
        home: { kind: 'match_winner', matchId: 83 },
        away: { kind: 'match_winner', matchId: 84 },
      },
      {
        id: 94, date: 'Mon 6 Jul', venue: 'Seattle',
        home: { kind: 'match_winner', matchId: 81 },
        away: { kind: 'match_winner', matchId: 82 },
      },
      {
        id: 95, date: 'Tue 7 Jul', venue: 'Atlanta',
        home: { kind: 'match_winner', matchId: 86 },
        away: { kind: 'match_winner', matchId: 88 },
      },
      {
        id: 96, date: 'Tue 7 Jul', venue: 'Vancouver',
        home: { kind: 'match_winner', matchId: 85 },
        away: { kind: 'match_winner', matchId: 87 },
      }
    ],
  },
  {
    name: 'Quarter-finals',
    matches: [
      {
        id: 97, date: 'Thu 9 Jul', venue: 'Boston',
        home: { kind: 'match_winner', matchId: 89 },
        away: { kind: 'match_winner', matchId: 90 },
      },
      {
        id: 98, date: 'Fri 10 Jul', venue: 'Los Angeles',
        home: { kind: 'match_winner', matchId: 93 },
        away: { kind: 'match_winner', matchId: 94 },
      },
      {
        id: 99, date: 'Sat 11 Jul', venue: 'Miami',
        home: { kind: 'match_winner', matchId: 91 },
        away: { kind: 'match_winner', matchId: 92 },
      },
      {
        id: 100, date: 'Sat 11 Jul', venue: 'Kansas City',
        home: { kind: 'match_winner', matchId: 95 },
        away: { kind: 'match_winner', matchId: 96 },
      }
    ],
  },
  {
    name: 'Semi-finals',
    matches: [
      {
        id: 101, date: 'Tue 14 Jul', venue: 'Dallas',
        home: { kind: 'match_winner', matchId: 97 },
        away: { kind: 'match_winner', matchId: 98 },
      },
      {
        id: 102, date: 'Wed 15 Jul', venue: 'Atlanta',
        home: { kind: 'match_winner', matchId: 99 },
        away: { kind: 'match_winner', matchId: 100 },
      }
    ],
  },
  {
    name: '3rd Place',
    matches: [
      {
        id: 103, date: 'Sat 18 Jul', venue: 'Miami',
        home: { kind: 'match_runner_up', matchId: 101 },
        away: { kind: 'match_runner_up', matchId: 102 },
      }
    ],
  },
  {
    name: 'Final',
    matches: [
      {
        id: 104, date: 'Sun 19 Jul', venue: 'New York/NJ',
        home: { kind: 'match_winner', matchId: 101 },
        away: { kind: 'match_winner', matchId: 102 },
      }
    ],
  }
];
